module.exports = __webpack_public_path__ + "img/qualificacao-5.0d1eb085.png";